import Vue from 'vue'
import { router } from '@src/routes'
import { mapState } from 'vuex'
import onScrollAnimate from '@assets/js/scrollAnimate.js'
import filterContainer from '@components/ui-components/filter-container/filter-container.vue'
import filterSearch from '@components/ui-components/filter-search/filter-search.vue'
import LoadMore from '@components/ui-components/load-more/load-more'

export default {
  name: 'solutions-selection-widget',
  components: {
    'filter-container-cmp': filterContainer,
    'filter-search-cmp': filterSearch,
    'load-more-cmp': LoadMore,
  },
  data() {
    return {
      newRows: {},
      pagination: null,
      visibleVendor: null,
      currentFormName: null,
      disableLoadMore: false,
    }
  },
  mounted() {
    this.setPagination()
  },
  beforeRouteUpdate(to, from, next) {
    if (this.currentFormName && to.query[`${this.currentFormName}[loadMore]`]) {
      let url =
        process.env.NODE_ENV !== 'production'
          ? 'questionnaires/index.json'
          : document.querySelector('.js-pagination').getAttribute('data-pagination-url')

      Vue.http.get(url, { params: to.query }).then(
        data => {
          next()
          if (!this.newRows[this.currentFormName]) {
            this.newRows[this.currentFormName] = []
          }
          this.newRows[this.currentFormName] = this.newRows[this.currentFormName].concat(data.data.items)
          this.pagination = data.data.pagination
          setTimeout(() => {
            onScrollAnimate()
          }, 10)
        },
        () => {
          next('/404')
        }
      )
    } else {
      this.disableLoadMore = true
      const path = to.path.replace(router.history.base, '')
      this.$root.setDataAnimateFalse('.js-vendors ')

      Vue.http.get(`templates${path}`, { params: to.query }).then(
        data => {
          next()
          setTimeout(() => {
            this.template = data.data
            this.newRows[this.currentFormName] = []
            this.setPagination()
            this.disableLoadMore = false
          }, 500)
        },
        () => {
          this.disableLoadMore = false
          next('/404')
        }
      )
    }
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  methods: {
    setCurrentFormName(value) {
      this.currentFormName = value
    },
    setPagination() {
      setTimeout(() => {
        this.pagination = this.$root.convertTwigToJs('pagination', '.js-pagination')
      }, 100)
    },
    openVendor(index) {
      if (this.visibleVendor === index) {
        this.visibleVendor = null
      } else {
        this.visibleVendor = index
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/widget/solutions-selection/component.js